import { render, staticRenderFns } from "./RoomInfoCard.vue?vue&type=template&id=30367d71&scoped=true"
import script from "./RoomInfoCard.vue?vue&type=script&lang=js"
export * from "./RoomInfoCard.vue?vue&type=script&lang=js"
import style0 from "./RoomInfoCard.vue?vue&type=style&index=0&id=30367d71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30367d71",
  null
  
)

export default component.exports